import { nanoid } from 'nanoid';
const namespaced = true;
class State {
    constructor() {
        this.items = [];
    }
}
const getters = {
    getAlertsList: state => state.items
};
const actions = {
    openAlert({ getters, commit }, payload) {
        const id = nanoid(8);
        commit('addAlert', Object.assign({ id }, payload));
        if (payload.autoDelete) {
            setTimeout(() => {
                commit('removeAlert', id);
            }, 5000);
        }
        return id;
    },
    removeAlert({ commit, state }, payload) {
        const neededAlertIndex = state.items.findIndex((item) => {
            if (item.id === payload) {
                return item;
            }
        });
        if (neededAlertIndex === -1) {
            return;
        }
        const alert = state.items[neededAlertIndex];
        if (alert.onClose !== undefined) {
            alert.onClose();
        }
        commit('removeAlert', neededAlertIndex);
    }
};
const mutations = {
    addAlert(state, payload) {
        state.items.push(payload);
    },
    removeAlert(state, payload) {
        state.items.splice(payload, 1);
    }
};
export default {
    namespaced,
    state: new State(),
    actions,
    getters,
    mutations
};
